import { render, staticRenderFns } from "./DonutChart102.vue?vue&type=template&id=2c3a0398&scoped=true"
import script from "./DonutChart102.vue?vue&type=script&lang=js"
export * from "./DonutChart102.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a0398",
  null
  
)

export default component.exports